export default [["en-us", {
  "device_offline_error": "Your device seems to be offline, so sending messages won't work at the moment. We'll keep trying to reconnect, or you can retry.",
  "disabled_conversation_error": "Something went wrong on our end. Please refresh the page.",
  "empty_list_header": "Welcome to Secure Messaging",
  "empty_list_text": "You don't have any conversations yet",
  "general_error": "Something went wrong on our end. Please try again.",
  "home": {
    "header": {
      "existingClient": "Existing Client?"
    },
    "hero": {
      "contact": "Contact",
      "existingClient": "I'm an Existing Client",
      "newClient": "I'm a New Client"
    }
  },
  "message_placeholder": "Send a message",
  "message_status": {
    "delivered": "Delivered",
    "failed": "Failed to send. Click to retry",
    "sending": "Sending..."
  },
  "navigation": {
    "conversation_list": "Secure messages {amount, plural, =0 {} other {({amount})}}"
  },
  "new_line_hint": {
    "effect": "to add a new line",
    "keys": "Shift + Return"
  },
  "retry_connection": "Retry connection",
  "send": "Send",
  "truncated_system_message": {
    "footer": "Your Account Owner can request a Data Export at any time from their account, contact them for more information.",
    "text": "Your Messaging history with this client prior to {date} is available via the Practice Data Export. {footer}"
  },
  "unread_message_indicator": "Unread message indicator"
}], ["es-mx", {
  "device_offline_error": "Your device seems to be offline, so sending messages won't work at the moment. We'll keep trying to reconnect, or you can retry.",
  "disabled_conversation_error": "Something went wrong on our end. Please refresh the page.",
  "empty_list_header": "Welcome to Secure Messaging",
  "empty_list_text": "You don't have any conversations yet",
  "general_error": "Something went wrong on our end. Please try again.",
  "home": {
    "header": {
      "existingClient": "¿Cliente Existente?"
    },
    "hero": {
      "contact": "Contacto",
      "existingClient": "Soy un Cliente Existente",
      "newClient": "Soy un Cliente Nuevo"
    }
  },
  "message_placeholder": "Send a message",
  "message_status": {
    "delivered": "Delivered",
    "failed": "Failed to send. Click to retry",
    "sending": "Sending..."
  },
  "navigation": {
    "conversation_list": "Secure messages {amount, plural, =0 {} other {({amount})}}"
  },
  "new_line_hint": {
    "effect": "to add a new line",
    "keys": "Shift + Return"
  },
  "retry_connection": "Retry connection",
  "send": "Send",
  "truncated_system_message": {
    "footer": "Your Account Owner can request a Data Export at any time from their account, contact them for more information.",
    "text": "Your Messaging history with this client prior to {date} is available via the Practice Data Export. {footer}"
  },
  "unread_message_indicator": "Unread message indicator"
}]];